export const ADD_PERSONAL_DETAILS = "ADD_PERSONAL_DETAILS";
export const ADD_PROFILE_DETAILS = "ADD_PROFILE_DETAILS";
export const ADD_INTERESTS = "ADD_INTERESTS";
export const ADD_LOCATIONS = "ADD_LOCATIONS";
export const RECEIVE_MESSAGES = "RECEIVE_MESSAGES";
export const CLEAR = "CLEAR";
export const ACCEPT_TERMS = "ACCEPT_TERMS";
export const ACCEPT_CODE = "ACCEPT_CODE";
